import { BLOCKS } from '@contentful/rich-text-types'
import slugify from 'slugify'

import type { Block, Document, Inline, Text, Heading2, Heading3 } from '@contentful/rich-text-types'

export interface Headings extends Block {
  nodeType:
    | BLOCKS.HEADING_1
    | BLOCKS.HEADING_2
    | BLOCKS.HEADING_3
    | BLOCKS.HEADING_4
    | BLOCKS.HEADING_5
    | BLOCKS.HEADING_6
  data: object
  content: Array<Inline | Text>
}

const AllowIdHeading = [BLOCKS.HEADING_2, BLOCKS.HEADING_3]

export const getHeadText = (block: Headings) =>
  block.content.map((cItem) => (cItem.nodeType === 'text' ? cItem.value : '')).join('')

export const addIdToHeadings = (richText?: Document) => {
  if (!richText) return undefined

  const richContent = richText.content || richText
  richContent.forEach((item) => {
    if (AllowIdHeading.includes(item.nodeType)) {
      item.data.id = slugify(getHeadText(item as Heading2 | Heading3), {
        lower: true,
      })
    }
  })
}
